import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=10ae6c22&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=10ae6c22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae6c22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10ae6c22')) {
      api.createRecord('10ae6c22', component.options)
    } else {
      api.reload('10ae6c22', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=10ae6c22&scoped=true", function () {
      api.rerender('10ae6c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/ColorPicker.vue"
export default component.exports